import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import ColumnList from "./EmployeeOrderColumnList";
import arrayMove from "array-move";
import Loading from "components/Loading";
import { employeesService } from "services";
import { mergeVisibleEmployeeOrder } from "utils/employeeGroupOrder";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as employeesActions from "actions/employeesActions";
import { withTranslation } from "react-i18next";

class EmployeeOrderModal extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.state = {
			group_employees: [],
			saved_group_order: [],
			loading: true,
			submitted: false,
			errors: {},
		};
	}

	getPlannedEmployeesMap = () => {
		const { planAssignments = [] } = this.props;
		const plannedEmployeesMap = new Map();

		planAssignments.forEach((assignment) => {
			const employee = assignment?.employee;
			if (employee?.id && !plannedEmployeesMap.has(employee.id)) {
				plannedEmployeesMap.set(employee.id, employee);
			}
		});

		return plannedEmployeesMap;
	};

	getPlannedEmployeesOrdered = (ordered_group_employees) => {
		const plannedEmployeesMap = this.getPlannedEmployeesMap();
		const plannedOrdered = ordered_group_employees.filter((employee) =>
			plannedEmployeesMap.has(employee.id)
		);
		const orderedIds = new Set(plannedOrdered.map((employee) => employee.id));
		const missingPlannedEmployees = Array.from(plannedEmployeesMap.values()).filter(
			(employee) => !orderedIds.has(employee.id)
		);

		return [...plannedOrdered, ...missingPlannedEmployees];
	};

	async componentDidMount() {
		const { group } = this.props;
		try {
			const group_employees_response =
				await employeesService.getEmployeesByGroupOrdered(group.id);
			const ordered_group_employees = group_employees_response.ok
				? group_employees_response.data
				: [];
			const plannedEmployeesMap = this.getPlannedEmployeesMap();
			let group_employees = ordered_group_employees;

			if (plannedEmployeesMap.size > 0) {
				group_employees = this.getPlannedEmployeesOrdered(
					ordered_group_employees
				);
			}

			this.setState({
				group_employees,
				saved_group_order: ordered_group_employees,
				loading: false,
			});
		} catch (error) {
			this.setState({
				loading: false,
				errors: { details: this.props.t("employees.orderModal.loadError") },
			});
		}

	}

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	prepareColumnsSubmit = () => {
		const { group_employees, saved_group_order } = this.state;

		return mergeVisibleEmployeeOrder(saved_group_order, group_employees).map(
			(employee) => employee.id
		);
	};


	handleSubmit = async (event) => {
		event.preventDefault();
		const { group } = this.props;

		this.setState({ loading: true });
		const props = this.props;

		const employee_list_ids = this.prepareColumnsSubmit();

		const response = await employeesService.updateEmployeesOrder(employee_list_ids, group.id);

		// console.log(response);

		if (response.ok) {
			this.setState(
				{
					loading: false,
					errors: {},
				},
				async () => {
					toastr.success(this.props.t("common.success"), this.props.t("employees.orderModal.savedOk"));
					await props.handleEmployeeOrderSaved(employee_list_ids);
					props.getAccountAssignments();
					props.syncRowHeights();
					props.handleClose();
				}
			);
		} else {
			this.setState({
				loading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	onSortEnd = ({ oldIndex, newIndex }) => {
		// console.log(oldIndex);
		// console.log(newIndex);
		this.setState(({ group_employees }) => ({
			group_employees: arrayMove(group_employees, oldIndex, newIndex),
		}));
	};


	render() {
		const { group_employees, errors } = this.state;
		const { group } = this.props;

		if (this.state.loading) {
			return <Loading />;
		}

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body group-employees-order">
					<p className="text-info">{this.props.t("employees.orderModal.descriptionPre")} <strong>{group.name}</strong>{this.props.t("employees.orderModal.descriptionPost")}</p>

					<div className="column-wrap">
						<ColumnList
							helperClass="column-item-active"
							onSortEnd={this.onSortEnd}
							handleColumn={this.handleColumn}
							items={group_employees}
							useDragHandle
						/>
					</div>

					{errors.details && (
						<p className="invalid-feedback d-block">{errors.details}</p>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.loading}
						text={this.props.t("common.save")}
						loadingText={this.props.t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (state, myProps) => {
	return {
		...state.employeesReducer,
		employee: myProps.employee,
	};
};

export default connect(mapStateToProps, employeesActions)(withTranslation()(EmployeeOrderModal));
